export const Bio = {
    name: "Arijit Roy",
    roles: [
      "Full Stack Developer",
      "Android Developer",
      "UI/UX Designer",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/Kitturoy",
    resume:
      "https://docs.google.com/document/d/1uxAShZa9GwQWLhHSORJ2oseTnvPH7p_AvKTMflNbg_E/edit?usp=sharing",
    linkedin: "https://www.linkedin.com/in/arijit--roy/",
    twitter: "https://x.com/kitturoy309?t=ny9crhqZKasiu4xj73lFnw&s=09",
    insta: "https://www.instagram.com/___arijit____roy____?igsh=aW40dXk2d2VxZDJv",
    facebook: "https://www.facebook.com/arijit.roy1999?mibextid=ZbWKwL",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
            name: "WordPress",
            image:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAY1BMVEUejL4Wir0AhLpUoMh3sNEAhrs5lcPH3ev////s8/jT5O/J3utFmcUAgbmlyd+exd0Ag7qVwNqz0eTm7/YAh7sAf7ff6/MAerW91udKm8bA2Oh/tdRzrtCHuNb1+ftnqM0AdLLTUtVNAAABFElEQVR4Ab2S12LDIAxFLWHFFwgjBGNnePz/V5Z0ZT+2bDiAZvMPhWp5g5hV2yrmF1w2HbQxGnYrj8x5BGKRKDsk98DsPufP/0j6vbmj7MvAJCxSxwQkvoEbjGNpvE2jaZ0GcKDrwyMAItkBJ8kBKFauEGdgyiRAPeUZE34hKT0AhhvuAG7qU1UW+oGt6UeAiOoHJ6IWQzflK2R1+Td7wLKEY1/h9dvoNAzHfaXCZXHXb5sIkXqcD922/stwEfmqrd3Jph6npdew5zFOhq+h2oJjgS2cA9ApB3UTGkllmIBUrQPm1Rz5zvGmOFzuc0GwJT6EJUHrgdm1wBif8uBgUbquwCh+kUAiyzQtmd+kEeVMzd+XD2XmDvZkVcEIAAAAAElFTkSuQmCC",
          },
        // {
        //   name: "Redux",
        //   image:
        //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        // },
        {
          name: "Next Js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
       
        // {
        //   name: "Flutter",
        //   image:
        //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
        // },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
        },
        // {
        //   name: "Graph Ql",
        //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
        // },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        // {
        //   name: "Kotlin",
        //   image:
        //     "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
        // },
        {
          name: "XML",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
        },
        {
          name: "Android Studio",
          image:
            "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
        },
        {
          name: "Adobe XD",
          image:
            "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
        },
        // {
        //   name: "Docker",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",          
        // },
        {
          name: "Linux",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
        },
        // {
        //   name: "Figma",
        //   image:
        //     "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
        // },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
      role: "DevOps & Fullstack Engineering Intern",
      company: "Flipr Inovations Pvt. Ltd.",
      date: "Aug 2023 - July 2023",
      desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
      skills: [
        "Docker",
        "Terraform",
        "AWS",
        "EC2",
        "Portainer",
        "Nginx",
        "JavaScript",
        "TypeScript",
        "Node Js",
        " Next Js",
      ],
      doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
      role: "Frontend Engineer Intern",
      company: "Neurobit",
      date: "June 2023 - Present",
      desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
      ],
      doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    },
    {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
      role: "Fullstack Externship",
      company: "Flipr",
      date: "June 2023 - July 2023",
      desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
        "Docker",
        "AWS",
        "MongoDB",
      ],
    },
    {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
      role: "Open Source Contributor ",
      company: "GirlScript Summer of Code",
      date: "May 2023 - Present",
      desc: "Contributing to different open-source projects and learn from industry experts",
      doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
      role: "Android Developer",
      company: "DSC KIIT",
      date: "Nov2021 - Present",
      desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
      skills: [
        "Leadership",
        "Mobile Application Development",
        "Kotlin",
        "XML",
        "Figma",
      ],
    },
    {
      id: 4,
      img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
      role: "Android Developer Intern",
      company: "Rudraksha Welffare Foundation",
      date: "June 2021 - Oct 2021",
      desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
      skills: [
        "Android",
        "Java",
        "Kotlin",
        "XML",
        "Node Js",
        "Cloud Firestore",
        "Firebase",
        "Figma",
      ],
      doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "data:image/jpeg;base64,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",
      school: "RCC Institute of Information Technology, Kolkata, West Bengal",
      date: "Oct 2021 - Aug 2023",
      grade: "8.68 CGPA",
      desc: "I am complete my Master's degree in Computer Applications and Engineering at RCC Institute of Information Technology(RCCIIT), Kolkata, West Bengal",
      degree: "Master of Computer Application - MCA, Computer Application and Computer Science and Engineering",
    },
    {
      id: 0,
      img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA4CAMAAAC8A5r5AAAAeFBMVEX///+bCBCTAACZAACWAACQAADWtbX07e3izcz59vbx6ej7+fj9/PzPqans39/TsLDav7/GmprFkpLm1NTdxsbn2dizamqzZmfLoKDAh4e8gYHYurmsWVm3dHXAjIygOTqoTE2bICKZFRilREWfKy2JAACsU1WdMTJh5jyVAAADvUlEQVRIiYWW2YKDKBBFEUUWZRNU3GK2Sf//Hw7gFjPpHh5MAoei6nLBAPClUfqt9z+UbBOY3GHS5sWfIGtQZ8oS47IwHWrw72QPFVCcK0L804IBXX4LCSsg+R4Jcwm65GtgggSrTvnRChtUfyOpUp+dg8XIfHYKVOTfAgwUsXNXgZg6ptMjD2IFPKOPXGyr03yEsFHl+jNnfHwn8xfQCydfKEuTJM1gOyx0BR7vNaAykJhfI7e0NEPt4DMpHUUHedHMMvdACGahJQcNx7xQtNNHTUDjPrk5EpqpDjbLEJywBntYVzEb9KrGKgrzWJNI4bMSHABFe76ikLr1Ww1fFwEoDPGSVIeJjTckx8kybq5gmwT+cV3bVFOWvK5PGF378C7gYBZxuPfbt6E3wOHcV31zTxMYd2/0Y8LIxWOw3NYP81+pLzwN2WZRzkfIgtNb+I5vx/qg76HnQvPFDzFqSMOBmM3QY3JIzKzrmqZtJ20XI0RnKDoFjbpBradOTFvszf3TaiFMZOU/rmJff561oMLNNZk5o0Jfk21EmtY/k2JHc2suTU+EJFj1TUfEfrY4fQYBjqpozGDS7iKXRHZXc4+BInsTIDqzAlTH4sEVnFB6+0BFj/0+wHxbZEWzAuDnG9qUoEZT2/Zp5jsJf0Pv9IxOFJCHIvVlRH4/c3VGTwlMJWbTD8ymvg2Hh7yhPoECnnLlP74ikzsj74N6jwrPYnkUowxOQvTeAkWt36P656046TqnSfaavbGvq3YLiucQqZZbR+4X9ycrbb0TM+/MdruSy4E0QXG5OztIbmCSNqM3tvd93a0DwrjgaTvRNX15DXP8CW/GDIYyBFyvsaFsgxp0r6sgTVjSVFWnvfvUfCFsqwrFq+aJjwPD5l2g5u3K5myOnxWvw3nES4RpnTcuc0TIyQi99Ipla41bBvv8eALVhSgObBf9k0W0zl0MPPpR28cgbtD+RynFvMk5lSGGNtbyoOQPKMMQ5sqSsLAE7V4BKmIqztT+LVT749gwYOTgSb5sVXYUOJVxx6yspVVSto1/eTlZc7IoNQ6HGJDJmHeZS2NMbtWQGyIXgA317SCBuYNNxdo1w6VTkxZrxwVA8YaCvtsvLiaAtaLY3jcaTB+vz5sVi5IAa2EH5VYhOcvnM+kvea/rlsMwbEtyQWD5gXr7E6Y/OzW28MvfCAw5qE4vVKKBTr7/4RgftNZ2/VFaLfDcfgV9U6inOOex5RhP0P5GhjKS2RlcFJjo513+AYYmXPtzv8+NY/8D/tX+BRlVObtLCrRLAAAAAElFTkSuQmCC",
      school: "Netaji Subhash Engineering College, Kolkata, West Bengal",
      date: "Aug 2018 - july 2021",
      grade: "8.39 CGPA",
      desc: "I am complete my Bachelor's degree in Computer Applications and Engineering at Netaji Subhash Engineering College (NSEC), Kolkata, West Bengal. I have completed 6 semesters and have a CGPA of 8.39. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
      degree: "Bachelor of Computer Application - BCA, Computer Application and Engineering",
    },
    {
      id: 2,
      img: "https://www.midnapore.in/schools/town_school/logo.jpg",
      school: "Midnapore Town School, Paschim Medinipur",
      date: "Apr 2017 - Apr 2018",
      grade: "56%",
      desc: "I completed my class 12 high school education at Midnapore Town School, Paschim Medinipur, where I studied Science.",
      degree: "WBCHSE(XII), Science ",
    },
    {
      id: 3,
      img: "https://targetstudy.com/files/img/2/51061/L_71507.gif",
      school: "Vidyasagar Vidyapith Boys High School, Paschim Medinipur",
      date: "Apr 2017 - Apr 2019",
      grade: "64.5%",
      desc: "I completed my class 10 education at Vidyasagar Vidyapith Boys High School, Paschim Medinipur, where I studied Science.",
      degree: "WBBSE(X), Science ",
    },
  ];
  
  export const projects = [
    {
      id: 9,
      title: "Flappy Bird-game",
      date: "Jan 2024 - Jan 2024",
      description:
        "Flappy Bird-game is a web application designed to game. It a user-friendly interface. A game based on genetic algorithm & neural networks in JavaScript.",
      image:
        "https://github.com/Kitturoy/flappy-bird-game/assets/115938624/178e4873-ed0e-45ea-8a98-177c87791c85",
      tags: [ "React Js", "Javascript", "HTML" ],
      category: "web app",
      github: "https://github.com/Kitturoy/flappy-bird-game",
      webapp: "https://flapppy-bird.netlify.app/",
    },
    {
      id: 0,
      title: "Pay As You Go Model",
      date: "Sep 2022 - Jan 2023",
      description:
        "Use CloudAnalyst tool developed at the University of Melbourne whose goal is to support evaluation of social networks tools according to geographic distribution of users and data centers. A CloudSim -based Tool for Modelling and Analysis of Large Scale Cloud Computing Environments and Vm management.",
      image:
      "https://4.bp.blogspot.com/-P7ClnDyuo4c/UQO5fJKAHII/AAAAAAAAAwg/NwxbI_2PP5Q/s1600/3%5B1%5D.png",
      tags: ["Java", "cloudsim"],
      category: "web app",
      github: "https://github.com/Kitturoy/pay-as--you-go/tree/master/submit",
      webapp: "https://github.com/Kitturoy/pay-as--you-go/tree/master/submit/",
      // member: [
      //   {
      //     name: "Rishav Chanda",
      //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
      //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
      //     github: "https://github.com/rishavchanda/",
      //   },
      //   // {
      //   //   name: "Upasana Chaudhuri",
      //   //   img: "https://avatars.githubusercontent.com/u/100614635?v=4",
      //   //   linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
      //   //   github: "https://github.com/upasana0710",
      //   // },
      // ],
    },
    {
      id: 1,
      title: "Contacts-android Application",
      date: "MaY 2021 - July 2021",
      description:
        "This mirror application looks like a contact app,to add numbers and save them in Gmail.Implemented RESTful APIs and third-party libraries to enhance application functionality.",
      image:
        "https://github.com/Kitturoy/ANDROID-APPLICATION-DEVELOPMEN/assets/115938624/553767ca-b4de-4928-94f7-88688fdd43b2",
      tags: [" Android Studio software", "Java", "XML",],
      category: "android app",
      github: "https://github.com/Kitturoy/ANDROID-APPLICATION-DEVELOPMEN",
      webapp: "https://github.com/Kitturoy/ANDROID-APPLICATION-DEVELOPMEN",
    },
    {
      id: 2,
      title: "IPL Data- Analysis",
      date: "Feb 2021 - Mar 2021",
      description:
        "Analyst IPL player to maximum number of player score performance,Total Matches played at each Venue, winning      percentage,Most Number of Man of the Match Awards,Won the Toss & Bat First or Field,Match Winners based on each season,Matches Played each season.",
      image:
        "https://github.com/Kitturoy/PAY_AS_YOU_GO_MODEL/assets/115938624/84b8b254-edab-48e2-a250-d2812b1a0ce8",
      tags: ["Python", ],
      category: "machine learning",
      // github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
      webapp: "https://drive.google.com/file/d/1zweHDJxkOWrOUQCo0jpZnchKq-6DTFfm/view",
      // member: [
      //   {
      //     name: "Rishav Chanda",
      //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
      //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
      //     github: "https://github.com/rishavchanda/",
      //   },
      //   {
      //     name: "Upasana Chaudhuri",
      //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
      //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
      //     github: "https://github.com/upasana0710",
      //   },
      // ],
    },
    // {
    //   id: 3,
    //   title: "Buckoid",
    //   date: "Dec 2021 - Apr 2022",
    //   description:
    //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    //   image:
    //     "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
    //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    // },
    // {
    //   id: 10,
    //   title: "Job Finding App",
    //   date: "Jun 2023 - Jul 2023",
    //   description:
    //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    //   image:
    //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    //   tags: ["React Native", "JavaScript", "Axios"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Job-finder-App",
    //   webapp: "https://github.com/rishavchanda/Job-finder-App",
    // },
    // {
    //   id: 4,
    //   title: "Whatsapp Clone",
    //   date: "Jul 2021",
    //   description:
    //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    //   webapp: "https://whatsapp-clone-rishav.web.app",
    // },
    // {
    //   id: 5,
    //   title: "Todo Web App",
    //   date: "Jun 2021",
    //   description:
    //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    //   image:
    //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Todo-Web-App",
    //   webapp: "https://rishav-react-todo.netlify.app/",
    // },
    // {
    //   id: 6,
    //   title: "Breaking Bad",
    //   date: "Jun 2021",
    //   description:
    //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    //   image:
    //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    //   tags: ["React Js", "API", "Axios", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Breaking-Bad",
    //   webapp: "https://breaking-bad-webapp.netlify.app",
    // },
    // {
    //   id: 7,
    //   title: "Quiz App",
    //   date: "Dec 2020 - Jan 2021",
    //   description:
    //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    //   image:
    //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Quiz-Earn",
    //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
    // },
    // {
    //   id: 8,
    //   title: "Face Recognition",
    //   date: "Jan 2021",
    //   description:
    //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    //   image:
    //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    //   category: "machine learning",
    //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    // },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];
  